// TODO: rename this file to 'handleComponent'

export default {
  methods: {
    highlightField(value) {
      this.$emit('highlightField', value)
    }
  },

  computed: {
    parse() {
      return (item) => {
        if (typeof (item.value) === 'string') {
          return JSON.parse(item.value)
        } else {
          return item.value
        }
      }
    }
  }
}
